import type { AdminAuthResponse } from "@klyra/shared";
/**
 * Platform super-admin session — fully separate from the clinic auth store
 * (separate localStorage key, separate token). The admin console never shares
 * state with a clinic session.
 */
import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

interface AdminState {
	user: AdminAuthResponse["user"] | null;
	accessToken: string | null;
	setSession: (data: AdminAuthResponse) => void;
	clearSession: () => void;
	isAuthenticated: () => boolean;
}

export const useAdminStore = create<AdminState>()(
	persist(
		(set, get) => ({
			user: null,
			accessToken: null,
			setSession: (data) =>
				set({ user: data.user, accessToken: data.tokens.access_token }),
			clearSession: () => set({ user: null, accessToken: null }),
			isAuthenticated: () => Boolean(get().accessToken && get().user),
		}),
		{
			name: "klyra.admin",
			storage: createJSONStorage(() => localStorage),
		},
	),
);
